import IncidentList from '../components/IncidentList.vue';
import IncidentDetail from '../components/IncidentDetail.vue';
import IncidentComparison from '../components/IncidentComparison.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: IncidentList,
    meta: {
      title: 'Alert List',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Alerts'
        },
        {
          path: 'list',
          title: 'View Alerts'
        }
      ]
    }
  },
  {
    path: 'detail/:id',
    component: IncidentDetail,
    meta: {
      title: 'Alert Detail',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/incident',
          title: 'Alerts'
        },
        {
          path: '',
          title: 'Alert Details',
          isDisplayId: true
        }
      ]
    }
  },
  {
    path: 'detail/:id/comparison',
    component: IncidentComparison,
    meta: {
      title: 'Incident Detail',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/incident',
          title: 'Alerts'
        },
        {
          path: '/incident/detail',
          title: 'Alert Details',
          isDisplayId: true
        },
        {
          path: '',
          title: 'Compare Differences'
        }
      ]
    }
  }
];
